import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/category/:works_type",
      name: "category",
      component: () =>
        import("./views/Category.vue")
    },
    {
      path: "/creators",
      name: "creators",
      component: () =>
        import("./views/Creators.vue")
    },
    {
      path: "/creator/:creators_id",
      name: "creator",
      component: () =>
        import("./views/Creator.vue")
    },
    {
      path: "/checkout",
      name: "checkout",
      component: () =>
        import("./views/Checkout.vue")
    },
    {
      path: "/mypage",
      name: "mypage",
      component: () =>
        import("./views/Mypage.vue")
    }
  ]
});
